export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-flashlight-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line' },
  { slug: 'daily', name: '日常', icon: 'ri-sun-line' },
];

export const comics = [
  {
    id: 1,
    title: '女神降临',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comic%20cover%20art%20style%20featuring%20a%20beautiful%20young%20woman%20with%20long%20dark%20hair%20and%20soft%20makeup%20look%2C%20pastel%20pink%20background%2C%20clean%20illustration%20style%2C%20shojo%20manga%20aesthetic%2C%20delicate%20linework%2C%20romantic%20atmosphere%2C%20simple%20decorative%20elements&width=400&height=540&seq=comic-01&orientation=portrait',
    rating: 9.5,
    views: '1280万',
    chapters: 156,
    status: '连载中',
    author: '猫咪',
    description: '原本相貌平平的女高中生任晶晶，通过化妆技术华丽变身成为校园女神。然而，素颜的秘密让她在两个男生之间左右为难，一场关于美貌、自信与真爱的青春故事就此展开。',
    tags: ['恋爱', '校园', '化妆', '逆袭'],
    updatedAt: '2026-08-05',
    chapters_list: [
      { id: 1, title: '第1话 命运的相遇', date: '2024-01-15' },
      { id: 2, title: '第2话 化妆的力量', date: '2024-01-22' },
      { id: 3, title: '第3话 学校的传闻', date: '2024-01-29' },
      { id: 4, title: '第4话 两个世界', date: '2024-02-05' },
      { id: 5, title: '第5话 意外的邂逅', date: '2024-02-12' },
      { id: 6, title: '第6话 心跳加速', date: '2024-02-19' },
      { id: 7, title: '第7话 秘密被发现了', date: '2024-02-26' },
      { id: 8, title: '第8话 转学生的挑战', date: '2024-03-04' },
    ],
    featured: true,
  },
  {
    id: 2,
    title: '看脸时代',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20comic%20cover%20art%20featuring%20a%20handsome%20young%20man%20with%20sharp%20features%20and%20stylish%20hair%2C%20dramatic%20lighting%2C%20urban%20street%20vibe%2C%20bold%20colors%2C%20action%20drama%20aesthetic%2C%20clean%20manhwa%20illustration%20style%2C%20dark%20blue%20and%20orange%20contrast&width=400&height=540&seq=comic-02&orientation=portrait',
    rating: 9.7,
    views: '2560万',
    chapters: 198,
    status: '连载中',
    author: '朴泰俊',
    description: '因为长相丑陋而在学校饱受欺凌的朴亨锡，一夜之间拥有了完美的身材和帅气的外表，但这个身体只能在白天使用。当拥有新身体的亨锡开始复仇时，他才发现这个社会的真相远比他想象的更加黑暗。',
    tags: ['剧情', '社会', '励志', '校园'],
    updatedAt: '2026-08-04',
    chapters_list: [
      { id: 1, title: '第1话 两个身体', date: '2023-06-01' },
      { id: 2, title: '第2话 新的开始', date: '2023-06-08' },
      { id: 3, title: '第3话 转学生的秘密', date: '2023-06-15' },
      { id: 4, title: '第4话 学校霸王', date: '2023-06-22' },
      { id: 5, title: '第5话 夜晚的亨锡', date: '2023-06-29' },
      { id: 6, title: '第6话 不可告人的交易', date: '2023-07-06' },
    ],
    featured: true,
  },
  {
    id: 3,
    title: '神之塔',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20comic%20cover%20featuring%20a%20mysterious%20boy%20climbing%20a%20giant%20tower%2C%20epic%20adventure%20theme%2C%20magical%20atmosphere%2C%20golden%20and%20purple%20glowing%20energy%2C%20fantasy%20illustration%20style%2C%20clean%20lineart%2C%20dramatic%20composition&width=400&height=540&seq=comic-03&orientation=portrait',
    rating: 9.8,
    views: '3890万',
    chapters: 212,
    status: '连载中',
    author: 'SIU',
    description: '少年夜为了追寻唯一的挚友蕾哈尔，独自进入了神秘的神之塔。在这座塔中，每登上一层都意味着更接近自己的愿望，但也需要面对更加残酷的考验。这是一场关于友情、梦想与成长的奇幻冒险。',
    tags: ['奇幻', '冒险', '少年', '热血'],
    updatedAt: '2026-08-03',
    chapters_list: [
      { id: 1, title: '第1话 塔之入口', date: '2023-03-10' },
      { id: 2, title: '第2话 第一层考验', date: '2023-03-17' },
      { id: 3, title: '第3话 同伴的出现', date: '2023-03-24' },
      { id: 4, title: '第4话 王冠游戏', date: '2023-03-31' },
      { id: 5, title: '第5话 隐藏的力量', date: '2023-04-07' },
      { id: 6, title: '第6话 蕾哈尔的真相', date: '2023-04-14' },
    ],
    featured: true,
  },
  {
    id: 4,
    title: '甜蜜家园',
    category: 'horror',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20comic%20cover%20featuring%20a%20dark%20apartment%20building%20with%20eerie%20green%20glow%2C%20monster%20silhouette%20in%20the%20background%2C%20survival%20horror%20aesthetic%2C%20dark%20atmosphere%2C%20tense%20mood%2C%20thriller%20illustration%20style%2C%20clean%20lineart%2C%20ominous%20lighting&width=400&height=540&seq=comic-04&orientation=portrait',
    rating: 9.4,
    views: '1850万',
    chapters: 140,
    status: '已完结',
    author: '金坎比',
    description: '在末日降临的世界里，人们被困在一栋公寓楼中与各种怪物展开殊死搏斗。车贤秀和幸存的居民们必须在恐惧与绝望中找到生存的希望，同时面对人性最黑暗的一面。',
    tags: ['恐怖', '悬疑', '末世', '生存'],
    updatedAt: '2026-07-28',
    chapters_list: [
      { id: 1, title: '第1话 公寓', date: '2023-01-05' },
      { id: 2, title: '第2话 第一个夜晚', date: '2023-01-12' },
      { id: 3, title: '第3话 邻居们', date: '2023-01-19' },
      { id: 4, title: '第4话 怪物的规则', date: '2023-01-26' },
      { id: 5, title: '第5话 绝望中的希望', date: '2023-02-02' },
    ],
    featured: false,
  },
  {
    id: 5,
    title: '梨泰院Class',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20comic%20cover%20featuring%20a%20young%20man%20with%20determined%20expression%20in%20front%20of%20a%20restaurant%20in%20Itaewon%20street%2C%20warm%20night%20neon%20lights%2C%20business%20and%20revenge%20theme%2C%20modern%20urban%20setting%2C%20clean%20illustration%20style%2C%20dramatic%20mood&width=400&height=540&seq=comic-05&orientation=portrait',
    rating: 9.6,
    views: '2150万',
    chapters: 178,
    status: '已完结',
    author: '赵光真',
    description: '因不向权势低头而被退学、父亲也因意外去世的朴世路，在梨泰院开了一家小酒馆，开始了长达十五年的复仇计划。这是一部关于信念、成长与创业的励志故事。',
    tags: ['剧情', '创业', '复仇', '励志'],
    updatedAt: '2026-07-20',
    chapters_list: [
      { id: 1, title: '第1话 转学生', date: '2023-09-01' },
      { id: 2, title: '第2话 父亲的教诲', date: '2023-09-08' },
      { id: 3, title: '第3话 悲剧的发生', date: '2023-09-15' },
      { id: 4, title: '第4话 七年之后', date: '2023-09-22' },
    ],
    featured: false,
  },
  {
    id: 6,
    title: '僵尸校园',
    category: 'horror',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20zombie%20comic%20cover%20featuring%20students%20running%20in%20a%20school%20hallway%2C%20zombie%20outbreak%20theme%2C%20dark%20red%20and%20gray%20color%20scheme%2C%20survival%20horror%20aesthetic%2C%20tense%20atmosphere%2C%20clean%20manhwa%20illustration%20style%2C%20dynamic%20action%20pose&width=400&height=540&seq=comic-06&orientation=portrait',
    rating: 9.3,
    views: '1670万',
    chapters: 130,
    status: '已完结',
    author: '朱东根',
    description: '孝山高中突然爆发僵尸病毒，被困在校园里的学生们必须想尽一切办法生存下去。在逃亡的过程中，友情、爱情和人性面临着前所未有的考验。',
    tags: ['恐怖', '校园', '生存', '丧尸'],
    updatedAt: '2026-07-15',
    chapters_list: [
      { id: 1, title: '第1话 科学老师', date: '2023-04-10' },
      { id: 2, title: '第2话 第一个感染者', date: '2023-04-17' },
      { id: 3, title: '第3话 食堂大逃亡', date: '2023-04-24' },
      { id: 4, title: '第4话 广播室的幸存者', date: '2023-05-01' },
    ],
    featured: false,
  },
  {
    id: 7,
    title: '我的ID是江南美人',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comic%20cover%20featuring%20a%20pretty%20female%20college%20student%20with%20long%20wavy%20hair%20smiling%20softly%2C%20spring%20campus%20cherry%20blossoms%20background%2C%20youthful%20and%20fresh%20atmosphere%2C%20pastel%20color%20palette%2C%20clean%20shojo%20illustration%20style%2C%20delicate%20details&width=400&height=540&seq=comic-07&orientation=portrait',
    rating: 9.2,
    views: '1420万',
    chapters: 120,
    status: '已完结',
    author: '淇萌',
    description: '从小因外貌被嘲笑的姜美莱，在进入大学前做了整形手术，成为了"江南美人"。本想开始全新人生的她，却发现外表的改变并不能解决所有问题。',
    tags: ['恋爱', '校园', '整形', '成长'],
    updatedAt: '2026-07-10',
    chapters_list: [
      { id: 1, title: '第1话 新的开始', date: '2023-07-20' },
      { id: 2, title: '第2话 大学生活', date: '2023-07-27' },
      { id: 3, title: '第3话 学长都京锡', date: '2023-08-03' },
      { id: 4, title: '第4话 素颜的秘密', date: '2023-08-10' },
    ],
    featured: false,
  },
  {
    id: 8,
    title: '与神同行',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20comic%20cover%20featuring%20three%20grim%20reapers%20in%20traditional%20Korean%20hanbok%20standing%20in%20the%20afterlife%20realm%2C%20mystical%20golden%20and%20white%20glow%2C%20celestial%20atmosphere%2C%20epic%20fantasy%20illustration%20style%2C%20clean%20linework%2C%20dramatic%20composition&width=400&height=540&seq=comic-08&orientation=portrait',
    rating: 9.9,
    views: '3200万',
    chapters: 89,
    status: '已完结',
    author: '周浩旻',
    description: '消防员金自鸿因公殉职后，被三位阴间使者带往地狱，需要在49天内通过七大地狱的审判，才能获得转世的机会。这是一场关于人性、罪与罚的奇幻之旅。',
    tags: ['奇幻', '神怪', '感动', '人性'],
    updatedAt: '2026-06-30',
    chapters_list: [
      { id: 1, title: '第1话 死后世界', date: '2023-11-01' },
      { id: 2, title: '第2话 杀人地狱', date: '2023-11-08' },
      { id: 3, title: '第3话 怠惰地狱', date: '2023-11-15' },
      { id: 4, title: '第4话 谎言地狱', date: '2023-11-22' },
    ],
    featured: false,
  },
  {
    id: 9,
    title: '他人即地狱',
    category: 'thriller',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20psychological%20thriller%20comic%20cover%20featuring%20a%20young%20man%20looking%20suspiciously%20at%20neighbors%20in%20a%20dark%20corridor%2C%20creepy%20atmosphere%2C%20red%20and%20black%20color%20scheme%2C%20psychological%20horror%20aesthetic%2C%20tense%20mood%2C%20clean%20illustration%20style&width=400&height=540&seq=comic-09&orientation=portrait',
    rating: 9.5,
    views: '1750万',
    chapters: 112,
    status: '已完结',
    author: '金容基',
    description: '从地方来到首尔打工的尹钟宇，住进了一家便宜但阴森的考试院。随着时间推移，他发现这里的邻居们都藏着不可告人的秘密，而他自己也渐渐陷入了一场恐怖的心理漩涡。',
    tags: ['悬疑', '心理', '恐怖', '社会'],
    updatedAt: '2026-06-25',
    chapters_list: [
      { id: 1, title: '第1话 首尔的考试院', date: '2023-08-15' },
      { id: 2, title: '第2话 奇怪的邻居', date: '2023-08-22' },
      { id: 3, title: '第3话 牙医的诊所', date: '2023-08-29' },
    ],
    featured: false,
  },
  {
    id: 10,
    title: '全知读者视角',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20fantasy%20comic%20cover%20featuring%20an%20ordinary%20office%20worker%20transformed%20into%20a%20hero%20in%20a%20post-apocalyptic%20world%2C%20dramatic%20lighting%2C%20blue%20and%20gold%20energy%20effects%2C%20system%20interface%20holographic%20elements%2C%20clean%20manhwa%20illustration%20style&width=400&height=540&seq=comic-10&orientation=portrait',
    rating: 9.8,
    views: '2980万',
    chapters: 165,
    status: '连载中',
    author: 'sing N song',
    description: '平凡上班族金独子，是唯一一个读完了一部连载了三千多话的网络小说的人。当小说中的末日场景突然在现实中上演时，他凭借对剧情的了解，成为了这个世界唯一的"全知读者"。',
    tags: ['奇幻', '末世', '系统', '热血'],
    updatedAt: '2026-08-02',
    chapters_list: [
      { id: 1, title: '第1话 小说的结局', date: '2024-02-01' },
      { id: 2, title: '第2话 地铁站的变化', date: '2024-02-08' },
      { id: 3, title: '第3话 第一个剧本', date: '2024-02-15' },
      { id: 4, title: '第4话 最强的回归者', date: '2024-02-22' },
      { id: 5, title: '第5话 同伴的信任', date: '2024-02-29' },
    ],
    featured: true,
  },
  {
    id: 11,
    title: '社内相亲',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comedy%20comic%20cover%20featuring%20a%20cute%20office%20woman%20in%20elegant%20business%20attire%20smiling%20shyly%2C%20modern%20office%20background%2C%20romantic%20comedy%20vibe%2C%20warm%20pink%20and%20beige%20tones%2C%20clean%20illustration%20style%2C%20soft%20lighting&width=400&height=540&seq=comic-11&orientation=portrait',
    rating: 9.1,
    views: '890万',
    chapters: 98,
    status: '已完结',
    author: '海华',
    description: '普通职员申夏莉代替闺蜜去参加相亲，本想故意搞砸却被对方看中。更糟糕的是，这位相亲对象竟然是她的公司社长！一场啼笑皆非的办公室恋情拉开帷幕。',
    tags: ['恋爱', '职场', '喜剧', '契约'],
    updatedAt: '2026-06-15',
    chapters_list: [
      { id: 1, title: '第1话 代替相亲', date: '2024-03-01' },
      { id: 2, title: '第2话 他是社长', date: '2024-03-08' },
      { id: 3, title: '第3话 契约恋爱', date: '2024-03-15' },
    ],
    featured: false,
  },
  {
    id: 12,
    title: 'DICE',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20comic%20cover%20featuring%20a%20teenage%20boy%20holding%20a%20glowing%20magical%20dice%20with%20sparks%2C%20dark%20urban%20fantasy%20theme%2C%20mysterious%20blue%20glow%2C%20dynamic%20action%20pose%2C%20game-like%20elements%2C%20clean%20manhwa%20illustration%20style&width=400&height=540&seq=comic-12&orientation=portrait',
    rating: 9.3,
    views: '1100万',
    chapters: 135,
    status: '已完结',
    author: '尹贤硕',
    description: '被校园霸凌的平凡高中生东太，某天获得了一颗能够改变命运的"骰子"。每完成一个任务就能获得点数来提升自己。但随着游戏深入，他发现一切并没有想象中那么简单。',
    tags: ['动作', '游戏', '校园', '奇幻'],
    updatedAt: '2026-06-10',
    chapters_list: [
      { id: 1, title: '第1话 改变命运的骰子', date: '2023-12-01' },
      { id: 2, title: '第2话 第一次任务', date: '2023-12-08' },
      { id: 3, title: '第3话 点数的作用', date: '2023-12-15' },
    ],
    featured: false,
  },
];

export const faqs = [
  {
    question: '叮咚漫画网上的韩漫都是免费的吗？',
    answer: '是的，叮咚漫画网上的所有韩漫资源均免费向用户开放阅读。我们致力于为广大韩漫爱好者提供优质的免费阅读体验，无需付费即可畅享海量韩漫内容。',
  },
  {
    question: '如何在叮咚漫画网上找到最新更新的韩漫？',
    answer: '您可以通过首页的"最新更新"板块查看最近更新的漫画，也可以进入各个分类页面按更新时间排序浏览。我们每天都会及时更新最新的漫画章节，确保用户能够第一时间阅读到最新内容。',
  },
  {
    question: '叮咚漫画网的漫画画质如何？',
    answer: '叮咚漫画网的漫画资源均为高清画质，我们力求为用户提供最佳的阅读体验。所有漫画图片均经过优化处理，在保证清晰度的同时也兼顾了加载速度，让您享受流畅的阅读体验。',
  },
  {
    question: '叮咚漫画网支持哪些设备阅读？',
    answer: '叮咚漫画网采用响应式设计，完美适配电脑、平板和手机等多种设备。无论您使用哪种设备访问，都能获得舒适的阅读体验。在移动端阅读时，我们还特别优化了竖屏滚动体验。',
  },
  {
    question: '漫画章节更新频率是怎样的？',
    answer: '热门连载漫画通常每周更新一话，部分热门作品可能会更频繁。具体更新时间请关注各漫画详情页的更新状态。我们会在第一时间同步最新章节。',
  },
];

export const reviews = [
  {
    name: '小猫咪',
    avatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20girl%20avatar%20profile%20picture%20in%20manga%20style%20with%20soft%20pink%20hair%20and%20big%20eyes%2C%20clean%20illustration%2C%20simple%20background&width=80&height=80&seq=avatar-01&orientation=squarish',
    rating: 5,
    comment: '终于找到可以免费看韩漫的地方了！画质超棒，更新也快，每天必刷！',
    date: '2026-08-01',
  },
  {
    name: '追漫达人',
    avatar: 'https://readdy.ai/api/search-image?query=handsome%20anime%20boy%20avatar%20profile%20picture%20in%20manhwa%20style%20with%20dark%20hair%20and%20cool%20expression%2C%20clean%20illustration%2C%20simple%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
    rating: 5,
    comment: '分类很全，找漫画很方便。推荐给所有喜欢韩漫的朋友！',
    date: '2026-07-28',
  },
  {
    name: '甜甜酱',
    avatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20girl%20avatar%20profile%20with%20twin%20tails%20and%20happy%20smile%20in%20kawaii%20manga%20style%2C%20warm%20pastel%20colors%2C%20clean%20illustration&width=80&height=80&seq=avatar-03&orientation=squarish',
    rating: 4,
    comment: '《女神降临》太好看了！画风超赞，剧情也很有意思，停不下来！',
    date: '2026-07-25',
  },
  {
    name: '漫无止境',
    avatar: 'https://readdy.ai/api/search-image?query=anime%20boy%20avatar%20profile%20with%20glasses%20and%20gentle%20smile%20in%20manhwa%20style%2C%20intellectual%20look%2C%20clean%20illustration%2C%20simple%20background&width=80&height=80&seq=avatar-04&orientation=squarish',
    rating: 5,
    comment: '手机阅读体验非常好，通勤路上看漫画的最佳选择！推荐《神之塔》！',
    date: '2026-07-20',
  },
];

export function getComicById(id: number) {
  return comics.find((c) => c.id === id);
}

export function getComicsByCategory(slug: string) {
  if (slug === 'all') return comics;
  return comics.filter((c) => c.category === slug);
}

export function getRelatedComics(id: number, limit: number = 4) {
  const comic = getComicById(id);
  if (!comic) return [];
  return comics.filter((c) => c.id !== id && c.category === comic.category).slice(0, limit);
}